import { defineComponent as n, createBlock as l, openBlock as a, unref as p, mergeProps as c, withCtx as d, createElementVNode as o } from "vue";
import { RevIcon as m } from "@ds/components/Icon";
const f = /* @__PURE__ */ n({
  name: "IconWaterdrop",
  __name: "IconWaterdrop",
  props: {
    size: {},
    alternativeText: {}
  },
  setup(t) {
    const r = t;
    return (i, e) => (a(), l(p(m), c(r, { "view-box": "0 0 24 24" }), {
      default: d(() => [...e[0] || (e[0] = [
        o("path", { d: "M13.613 7.617a.75.75 0 0 0-1.226.864l1.735 2.465a.75.75 0 0 0 1.227-.863l-1.736-2.466" }, null, -1),
        o("path", {
          "fill-rule": "evenodd",
          d: "M12 21.652c4.341 0 7.75-3.732 7.75-7.95 0-1.033-.387-2.152-.922-3.222-.541-1.084-1.27-2.188-2.029-3.21-1.519-2.046-3.211-3.827-3.923-4.552a1.223 1.223 0 0 0-1.752 0C10.412 3.443 8.72 5.224 7.2 7.27c-.76 1.023-1.488 2.127-2.029 3.21-.535 1.071-.922 2.19-.922 3.223 0 4.218 3.409 7.95 7.75 7.95m6.25-7.95c0 3.453-2.8 6.45-6.25 6.45s-6.25-2.997-6.25-6.45c0-.69.27-1.562.764-2.552.488-.977 1.161-2.003 1.891-2.986 1.337-1.8 2.823-3.398 3.595-4.196.772.798 2.258 2.396 3.595 4.196.73.983 1.403 2.01 1.891 2.986.494.99.764 1.861.764 2.551",
          "clip-rule": "evenodd"
        }, null, -1)
      ])]),
      _: 1
    }, 16));
  }
});
export {
  f as default
};
